// extracted by mini-css-extract-plugin
export default {"label":"Switch_label__fkd5u","input":"Switch_input__nrQOf","fake-input":"Switch_fake-input__maVLD"};